<template>
  <div ref="partnersList" class="md-layout-item md-size-100 mx-auto md-alignment-top-center">
    <template v-if="showFilters">
      <div class="md-layout md-layout-item md-size-100">
        <md-field class="md-form-group md-layout-item md-size-100">
          <label>{{ $t('Search') }}</label>
          <md-input v-model="filters.search" v-on:keyup.enter="loadData(true)" />
        </md-field>

        <md-field class="md-form-group md-layout-item md-size-30 md-small-size-100">
          <label for="f_trade" style="margin-right:10px">{{$t('Trade')}}</label>
          <md-select v-model="filters.trade" name="f_thematicPath" md-dense>
            <md-option>{{$t('Show all')}}</md-option>
            <md-option v-for="v in lookups.trades" :key="v.value" :value="v.value">{{v.text}}</md-option>
          </md-select>
        </md-field>
      </div>

      <div class="md-layout md-layout-item md-size-100">
        <div class="ml-auto">
          <md-button
            @click="loadData(true);"
            class="md-round md-primary md-sm md-blue-border"
            style="margin:0px"
          >{{$t('Search')}}</md-button>
        </div>
      </div>
    </template>

    <template v-if="loaded">
      <template v-if="items.length">
        <div
          class="md-layout md-layout-item md-size-100 mx-auto"
          v-for="item in items"
          :key="item.id"
          style="margin:20px 0px 40px 0px"
        >
          <div class="md-layout-item md-size-100" style="margin-bottom:5px;">
            <h3
              class="bold text-primary"
              style="margin-bottom:6px text-transform:uppercase"
            >{{item.description.name}}</h3>
            <hr class="text-primary" />
          </div>
          <div class="md-layout-item md-layout md-size-100">
            <item
              class="md-layout-item md-layout md-size-25"
              v-for="partner in item.partners"
              :key="partner.id"
              :item="partner"
            />
          </div>
        </div>

        <!-- <item v-for="item in items" :key="item.id" :item="item" /> -->
      </template>
      <no-data v-else />
    </template>
  </div>

  <!-- <template v-if="loaded">
      <template v-if="items.length">
        <div
          class="md-layout md-layout-item md-size-100 mx-auto"
          v-for="item in items"
          :key="item.id"
          style="margin:20px 0px 40px 0px"
        >
          <div class="md-layout-item md-size-100" style="margin-bottom:5px;">
            <h3
              class="bold text-primary"
              style="margin-bottom:6px text-transform:uppercase"
            >{{item.description.name}}</h3>
            <hr class="text-primary" />
          </div>
          <div
            class="md-layout-item md-size-25 md-medium-size-50 md-xsmall-size-100"
            style="padding:10px"
            v-for="partner in item.partners"
            :key="partner.id"
          >
            <img
              :src="fileUrl(partner.description.logoId)"
              style="width:100%;cursor:pointer"
              @click="$router.push({name:'partnerDetails', params:{id:partner.id}})"
            />
          </div>
        </div>
      </template>
      <no-data v-else />
    </template> 
  </div>-->
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";
import NoData from "@/pages/authenticated/NoData";
import Item from "./PartnerListItem";

export default {
  components: { NoData, Item },
  props: ["showAll", "showFilters"],
  data() {
    return {
      filters: {},
      lookups: [],
      items: [],
      loaded: false
    };
  },
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current"
    })
  },
  methods: {
    async loadLookups() {
      if (this.showFilters) {
        this.lookups = (
          await axios.get("public/conferences/partners/lookup", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code
            }
          })
        ).data;
      }
    },
    async loadData(reloadLookups) {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        if (reloadLookups) {
          await this.loadLookups();
        }

        var parsedFilters = { ...this.filters };

        parsedFilters.trade = !!parsedFilters.trade
          ? parsedFilters.trade
          : null;

        this.items = (
          await axios.get("public/conferences/conference/partners", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code,
              all: this.showAll,
              ...parsedFilters
            }
          })
        ).data;
      } finally {
        this.loaded = true;
        loader.hide();
      }
    },
    fileUrl(id) {
      return axios.getFileUrl(id);
    }
  },
  watch: {
    async language() {
      await this.loadData(true);
    }
  },
  async mounted() {
    await this.loadData(true);
  }
};
</script>
